import React, { PureComponent, Fragment } from 'react';
import { func, string } from 'prop-types';
import classnames from 'classnames';
import { withLocalStorage } from 'connectors';
import { localStorageShape } from 'shapes';
import axios from 'axios';
import Trend from './Trend/Trend';

import './Trends.scss';

class Trends extends PureComponent {
    static propTypes = {
        className: string,
        onTrendSelected: func.isRequired,
        localStorage: localStorageShape.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    state = {
        trends: [],
    };

    componentDidMount() {
        this.props.localStorage.get().then(trends => {
            this.setState({ trends });
        });
    }

    handleTrendClick = (trend, evt) => {
        const { onTrendSelected } = this.props;
        if (onTrendSelected) {
            onTrendSelected(trend, evt);
        }
    };

    render() {
        const { className } = this.props;
        const { trends } = this.state;
        const rootClassnames = classnames('searchBar__trends', className);

        return (
            <div className={rootClassnames}>
                {trends.length > 0 && (
                    <Fragment>
                        <div className="searchBar__trends__title">
                            tendances de recherche
                        </div>

                        <div className="searchBar__trends__list">
                            {trends.map((trend, index) => (
                                <Trend
                                    key={`${trend}${index}`} // eslint-disable-line react/no-array-index-key
                                    trend={trend}
                                    onClick={this.handleTrendClick}
                                />
                            ))}
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}

const fetchTrends = () => axios.get('/trends').then(({ data }) => data);

const oneHourInMs = 60 * 60 * 1000;

export default withLocalStorage('searchTrends', fetchTrends, oneHourInMs)(
    Trends,
);
